// src/components/Subscription/SubscriptionSuccessHandler.jsx
// Handles redirect from Stripe checkout and refreshes auth state
// Place this inside BrowserRouter but outside Routes

import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function SubscriptionSuccessHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const upgradeStatus = params.get('upgrade');
    
    if (upgradeStatus === 'success') {
      console.log('[SubscriptionSuccess] ✅ Detected successful checkout return');
      
      // Show success message briefly
      setShowSuccess(true);
      
      // Clear the URL parameters
      params.delete('upgrade');
      params.delete('session_id');
      
      const newSearch = params.toString();
      const newUrl = location.pathname + (newSearch ? `?${newSearch}` : '');
      
      // Replace URL without reload first (to clean up the URL)
      window.history.replaceState({}, '', newUrl);
      
      // Wait a moment for webhook to process, then reload to refresh auth state
      setTimeout(() => {
        console.log('[SubscriptionSuccess] Reloading to refresh subscription state...');
        window.location.reload();
      }, 1500);
    }
    
    if (upgradeStatus === 'cancel') {
      console.log('[SubscriptionSuccess] ❌ User cancelled checkout');
      // Clear the cancel parameter
      params.delete('upgrade');
      const newSearch = params.toString();
      const newUrl = location.pathname + (newSearch ? `?${newSearch}` : '');
      window.history.replaceState({}, '', newUrl);
    }
  }, [location.search, location.pathname]);

  // Show a brief loading overlay during the refresh
  if (showSuccess) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(11, 20, 42, 0.95)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999,
        color: 'white',
        textAlign: 'center',
        padding: 24,
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🎉</div>
        <h2 style={{ margin: '0 0 8px', fontSize: 24, fontWeight: 700 }}>
          Welcome to VivaJour Pro!
        </h2>
        <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)', fontSize: 16 }}>
          Setting up your subscription...
        </p>
        <div style={{
          marginTop: 24,
          width: 40,
          height: 40,
          border: '3px solid rgba(255,255,255,0.2)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return null;
}
